export const MODE_FULLTEXT_SEARCH = 'fulltext';
export const MODE_HYBRID_SEARCH = 'hybrid';
export const MODE_VECTOR_SEARCH = 'vector';
//# sourceMappingURL=constants.js.map